import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Button, Progress } from "antd";

import { reportGeneratorCancelFetchRequest } from "../../../store/reports/actions";
import { ReportGeneratorStatus } from "../../../store/reports/types";
import { RootState } from "../../../store/root_reducer";
import { formatNumber } from "../../../utils/table";

import styles from "./styles.module.scss";

interface ReportItemProps {
  id: string;
}

export const ReportGeneratorItem: React.FC<ReportItemProps> = (props) => {
  const { t } = useTranslation("report_selector");
  const generator = useSelector((state: RootState) => state.Reports.generators[props.id]);

  const state = useMemo(() => {
    switch (generator.status) {
      case ReportGeneratorStatus.CANCELED:
      case ReportGeneratorStatus.FAILED:
        return { status: "exception", availableControls: false };
      case ReportGeneratorStatus.DONE:
        return { status: "success", availableControls: false };
      default:
        return { status: "active", availableControls: true };
    }
  }, [generator.status]);

  const dispatch = useDispatch();
  const handleOnCancel = () => {
    dispatch(reportGeneratorCancelFetchRequest({ id: props.id }));
  };

  return (
    <div className={styles.reportCard}>
      <div className={styles.reportCardDescription}>
        <span>{t("report", { id: generator.id.split("-")[0] })}</span>
        <span>{t(`report_name.${generator.reportType}`)}</span>
        <span className={styles.reportFileName}>{generator.fileName}</span>
      </div>
      <Progress
        type="dashboard"
        percent={generator.progress}
        width={60}
        status={state.status as any}
        format={(percent) => {
          switch (generator.status) {
            case ReportGeneratorStatus.IN_PROGRESS:
              return <span>{formatNumber(percent ?? 0, 1)} %</span>;
            default:
              return <span className={styles.reportStatus}>{generator.status}</span>;
          }
        }}
      />
      <div className={styles.reportControls}>
        {state.availableControls && (
          <Button type="primary" danger size="small" onClick={handleOnCancel}>
            Cancel
          </Button>
        )}
      </div>
    </div>
  );
};
